export default "/images/eb16df6a756e6d1fa13341e3799fe26a.avif";